module.exports = __webpack_public_path__ + "static/media/4-12.0f7118cb.png";